import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from './../services/authentication.service';
import CasClient, { constant } from "react-cas-client";
import { createBrowserHistory } from 'history';

//import fetch from 'node-fetch';

const APP_ID = process.env.REACT_APP_ID;
const API_URL = process.env.REACT_APP_API_URL;
const AUTH_URL = process.env.REACT_APP_AUTH_URL;
const CAS_SERVER = process.env.REACT_APP_CAS_SERVER;

const history = createBrowserHistory();

export const PrivateRoute = ({ component: Component, roles, ...rest }) => (
    <Route {...rest} render={props => {

        let currentUser = authenticationService.currentUserValue;
        if (!currentUser || !currentUser.idpersona) {

            //console.log("PrivateRout currentUser = " + JSON.stringify(currentUser));
            let casOptions = { version: constant.CAS_VERSION_2_0, path: '/', protocol: 'https' };
            let casClient = new CasClient(CAS_SERVER, casOptions);

            // Basic usage
            casClient
                .auth()
                .then(successRes => {
                    //console.log("CAS response = " + JSON.stringify(successRes));
                    const username = successRes.user;
                    if (username) {
                        //fetch(AUTH_URL + "Token?idApp=" + APP_ID).then((response) => console.log("response headers = " + JSON.stringify(response.headers)));
                        //fetch(API_URL + "Login", { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ idapp: APP_ID, netid: username }) })
                        fetch(API_URL + "Login", {
                            method: 'POST', headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ idapp: APP_ID, netid: username })
                        })
                            .then(response => response.json())
                            .then((result) => {
                                //console.log(JSON.stringify(result));

                                currentUser = {
                                    idpersona: result.user.idpersona,
                                    usuario: result.user.netId,
                                    identificacion: result.user.numeroidentificacion,
                                    apellidos: result.user.apellidos,
                                    nombres: result.user.nombres,
                                    roles: ["PROFESOR"],
                                    token: result.token
                                };
                                //console.log("JWT currentUser = " + JSON.stringify(currentUser));

                                //customFetch.fetch(token);
                                //let realFetch = window.fetch;
                                //window.fetch = function (url, opts = null) {
                                //    console.log("using custom fetch");
                                //    if (currentUser.token) {
                                //        opts = Object.assign({}, opts, { 'headers': { 'Content-Type': 'application/json', 'Authorization': `Bearer ${currentUser.token}` } });
                                //        return realFetch(url, opts);
                                //    } else {
                                //        //console.log("[fetch] url: " + url + " opts: " + JSON.stringify(opts));
                                //        return realFetch(url, opts);
                                //    }
                                //};

                                authenticationService.login(currentUser);

                            });
                    }
                    //fetch(AUTH_URL + "Token?idApp=" + APP_ID, { redirect: 'follow', credentials: 'include' })   // 
                    //    .then(response => response.json())
                    //    .then((result) => {
                    //        if (result) {
                    //            fetch(API_URL + 'login?idapp=' + result.idaplicacion + '&netid=' + result.netid + '&token=' + result.token)
                    //                .then(responseJwt => responseJwt.json())
                    //                .then((resultJwt) => {
                    //                    console.log("result JWT = " + JSON.stringify(resultJwt));
                    //                    if (resultJwt) {

                    //                        currentUser = {
                    //                            usuario: result.netid,
                    //                            token: resultJwt.token
                    //                        };
                    //                        console.log("JWT currentUser = " + JSON.stringify(currentUser));
                    //                        authenticationService.login(currentUser);

                    //                    }
                    //                })
                    //        }
                    //    })
                    history.replace(successRes.currentPath);
                })
                .catch(errorRes => {
                    console.error(errorRes);
                    // Error handling
                    // displayErrorByType(errorRes.type)

                    // Update current path to trim any extra params in url
                    // eg. this.props.history.replace(response.currentPath);
                });
        }

        
            
        //    if (!currentUser) {
        //        return <Route path='/login' component={() => {
        //            window.location.href = '/Account/Login';
        //            return null;
        //        }} />
        //    }
        //}

        //console.log("roles = " + JSON.stringify(roles));
        //console.log("currentUser roles = " + JSON.stringify(currentUser.roles));

        // check if route is restricted by role
        //if (roles && !roles.some(r => currentUser.roles.indexOf(r) >= 0)) {
        //    // role not authorised so redirect to home page
        //    return <Redirect to={{ pathname: '/' }} />
        //}

        // authorised so return component
        //console.log("Private Route componente props = " + JSON.stringify(currentUser));
        //console.log("Private Route props = " + JSON.stringify(props));
        return <Component currentUser={currentUser} {...props}/>
    }} />
)